var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCdcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77355 0H21.9429C23.0789 0 24 0.906619 24 2.025V17.55C24 19.7868 22.158 21.6 19.8857 21.6H4.8C5.36819 21.6 5.71641 20.7538 5.71641 19.7517V2.025C5.71641 0.906619 6.6375 0 7.77355 0ZM9.94286 14.85C9.37483 14.85 8.91429 15.3034 8.91429 15.8625C8.91429 16.4216 9.37483 16.875 9.94286 16.875H19.5429C20.1109 16.875 20.5714 16.4216 20.5714 15.8625C20.5714 15.3034 20.1109 14.85 19.5429 14.85H9.94286ZM8.91429 12.4875C8.91429 11.9284 9.37483 11.475 9.94286 11.475H19.5429C20.1109 11.475 20.5714 11.9284 20.5714 12.4875C20.5714 13.0466 20.1109 13.5 19.5429 13.5H9.94286C9.37483 13.5 8.91429 13.0466 8.91429 12.4875ZM9.94286 8.1C9.37483 8.1 8.91429 8.55335 8.91429 9.1125C8.91429 9.67165 9.37483 10.125 9.94286 10.125H19.5429C20.1109 10.125 20.5714 9.67165 20.5714 9.1125C20.5714 8.55335 20.1109 8.1 19.5429 8.1H9.94286ZM8.91429 5.7375C8.91429 5.17835 9.37483 4.725 9.94286 4.725H19.5429C20.1109 4.725 20.5714 5.17835 20.5714 5.7375C20.5714 6.29665 20.1109 6.75 19.5429 6.75H9.94286C9.37483 6.75 8.91429 6.29665 8.91429 5.7375Z",
    fill: "#284254"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.685714 3.375C0.307031 3.375 0 3.67723 0 4.05V19.575C0 20.6934 0.921094 21.6 2.05714 21.6C3.19319 21.6 4.11429 20.6934 4.11429 19.575V4.05C4.11429 3.67723 3.80725 3.375 3.42857 3.375H0.685714Z",
    fill: "#284254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdcIcon);
export default __webpack_public_path__ + "static/media/cdc-icon.a9bd573635009da24cb0d0bbeebc7c5a.svg";
export { ForwardRef as ReactComponent };